import NumberFormat from 'react-number-format';

import Moment from 'moment-timezone'
import { DefaultTooltip } from 'twyne-new.ui';

function CardTitle({ title, tipTitle, subtitle, tipSubtitle }) {
  return <>
    <DefaultTooltip content={tipTitle}>
      <span className='text-md'>{title}</span>
    </DefaultTooltip>
    {subtitle && <>
      <span className='mx-1'>-</span>
      <DefaultTooltip content={tipSubtitle}>
        <span className='text-sm twy-text-base'>{subtitle}</span>
      </DefaultTooltip>
    </>}
  </>
}

const formatUtcDate = date => {
  date = Moment.utc(date)
  if (date.isValid()) {
    return date.format('MM/DD/YYYY');
  }
  return ''
}

const formatBool = value => fallback({ false: "No", true: "Yes" }[value])

const fallback = value => [undefined, null, ''].includes(value) ? '--' : value

const getUrlLink = field => {
  switch (field) {
    case 'path':
      return `/path/paths`
    case 'allocation':
      return `/offer/allocations`
    case 'publisher':
      return `/offer/publishers`
    case 'userProfile':
      return `/path/dashboard`
    case 'page':
      return `/path/pages`
    case 'integration':
      return `/settings/integrations`
    default:
      return ''
  }
}

const formatMoney = value => <NumberFormat
  value={value?.toFixed(2) || 0}
  displayType="text"
  thousandSeparator=","
  decimalSeparator="."
  prefix={'$'}
  decimalScale={2}
  fixedDecimalScale={true}
/>

const formatData = (data, userIntegrations) => {
  const { pathSessions, path_actions, customFields, userSessions, isManagerAdmin, isSuperAdmin, organizationId, validationCode, active, ...userData } = data || {}

  const pathSessionsGrouped = pathSessions.map(pathSession => {
    pathSession.impressions = path_actions.filter(pathAction => pathAction.action !== 'finish' && pathAction.pathSessionId === pathSession.id)
    return pathSession
  })

  const userSessionsGrouped = userSessions.map(userSession => {
    userSession.pathSessions = pathSessionsGrouped.filter(pathSession => pathSession.user_session_id == userSession.id)
    userSession.integrations = userIntegrations.filter(integration => integration.u_session_id == userSession.id)
    return userSession
  })

  const pathSessionEmbed = pathSessions.filter(pathSession => !pathSession.userSessionId)
  const integrationsEmbed = userIntegrations.filter(integration => !integration.u_session_id)
  const pathSessionsEmbedGrouped = pathSessionEmbed.map(pathSession => {
    pathSession.impressions = path_actions.filter(pathAction => pathAction.action !== 'finish' && pathAction.pathSessionId === pathSession.id)
    return pathSession
  })

  return {
    userData: Object.entries(userData),
    userSessions: userSessionsGrouped,
    embed: {
      pathSessions: pathSessionsEmbedGrouped,
      integrations: integrationsEmbed,
    },
  }
}

export {
  formatData,
  fallback,
  formatBool,
  CardTitle,
  formatUtcDate,
  getUrlLink,
  formatMoney,
}
